import type { GrantType, UsageType } from '@/types/credit';

const USAGE_TYPE_TECH_EXPLORATION: UsageType = 'tech_exploration';
const USAGE_TYPE_PATENT_FTO_ANALYSIS: UsageType = 'patent_fto_analysis';
const USAGE_TYPE_UNKNOWN: UsageType = 'unknown';

export const USAGE_TYPE_DISPLAY_NAME: Record<UsageType, string> = {
  [USAGE_TYPE_TECH_EXPLORATION]: '技術探索',
  [USAGE_TYPE_PATENT_FTO_ANALYSIS]: '特許調査',
  [USAGE_TYPE_UNKNOWN]: '',
};

const GRANT_TYPE_TRIAL_FREE: GrantType = 'trial_free';
const GRANT_TYPE_SUBSCRIPTION_BASE: GrantType = 'subscription_base';
const GRANT_TYPE_CREDIT_PACK: GrantType = 'credit_pack';
const GRANT_TYPE_CAMPAIGN: GrantType = 'campaign';
const GRANT_TYPE_COMPENSATION: GrantType = 'compensation';
const GRANT_TYPE_ADJUSTMENT: GrantType = 'adjustment';
const GRANT_TYPE_TRIAL_END_CANCELLATION: GrantType = 'trial_end_cancellation';
const GRANT_TYPE_CONTRACT_CHANGE_ADJUSTMENT: GrantType =
  'contract_change_adjustment';

export const GRANT_TYPE_DISPLAY_NAME: Record<GrantType, string> = {
  [GRANT_TYPE_TRIAL_FREE]: 'トライアル',
  [GRANT_TYPE_SUBSCRIPTION_BASE]: '基本料金に含まれる無料枠',
  [GRANT_TYPE_CREDIT_PACK]: '追加購入',
  [GRANT_TYPE_CAMPAIGN]: 'キャンペーン',
  [GRANT_TYPE_COMPENSATION]: '補償',
  [GRANT_TYPE_ADJUSTMENT]: '調整',
  [GRANT_TYPE_TRIAL_END_CANCELLATION]: 'トライアル期間終了による取消',
  [GRANT_TYPE_CONTRACT_CHANGE_ADJUSTMENT]: '契約変更による調整分',
};

export const ZERO_CREDIT_BALANCE_WARNING_MESSAGE =
  '残高がありません。ストックマークの担当者に補充を依頼してください。';

export const CREDIT_BALANCE_ADJUSTED_MESSAGE =
  'エージェントの処理中断に伴い、クレジット利用量が調整されました';

export const INSUFFICIENT_CREDIT_MESSAGE =
  'クレジットが不足しています。社内の管理者に補充を依頼してください。';
